<template>
  <div class="text-left">
    <div class="mb-4">
      <div
        class="text-left custom-control custom-checkbox"
        :class="{ 'is-invalid': $v.checkbox.$error }"
      >
        <v-checkbox
          v-model="$v.checkbox.$model"
          :error="$v.checkbox.$error"
          class="mt-2"
          hide-details="auto"
          @change="updateValue"
          @click="sendGtmEvent(getLocaleText(inputData.label))"
        >
          <template #label>
            <span v-html="addNbsp(getLocaleText(inputData.label))" />
          </template>
        </v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { checked } from '@/customVuelidate';
import formGtm from '@/mixins/formGtm';

export default {
  name: 'UlCheckbox',
  mixins: [formGtm],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      checkbox: false
    };
  },
  validations() {
    if (this.inputData.required) {
      return {
        checkbox: { checked }
      };
    }
    return { checkbox: {} };
  },
  computed: {
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    }
  },
  created() {
    this.$v.checkbox.$model = this.responses[this.formName][this.inputData.id] || false;
    this.$v.$reset();
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => {
      this.$v.$touch();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    updateValue() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
      this.$store.dispatch('dynamicForms/updateResponse', {
        id: this.inputData.id,
        value: this.$v.checkbox.$model,
        formName: this.formName
      });
    }
  }
};
</script>
